import { useEffect } from 'react';
import { useSubNav } from '../contexts/SubNavContext';
import './Company.css';

export default function Company() {
    const { setSubNav } = useSubNav();

    useEffect(() => {
        // 컴포넌트 마운트 시 서브 네비게이션 설정
        setSubNav([
            { 
                href: '#mark1', 
                label: '개요', 
                active: true,
                onClick: (e) => {
                    e.preventDefault();
                    const el = document.getElementById('mark1')
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            },
            { 
                href: '#mark2', 
                label: '비전', 
                active: false,
                onClick: (e) => {
                    e.preventDefault();
                    const el = document.getElementById('mark2')
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            },
            { 
                href: '#mark3', 
                label: '미션', 
                active: false,
                onClick: (e) => {
                    e.preventDefault();
                    const el = document.getElementById('mark3')
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }
        ]);

        // 컴포넌트 언마운트 시 서브 네비게이션 제거
        return () => setSubNav(null);
    }, [setSubNav]);

    return (
        <><div className="container">
                <div className="cont_visual company">
                    <h2>토탈 IT서비스 전문기업</h2>
                    <p>
                        (주)와이앤씨스마트앱스는 정보통신시장의 진화 트랜드를 분석하는 인사이트와 웹 전반의 컨설팅 및 설계, 구축, 운영업무 수행 경험을 바탕으로<br />
                        고객을 위한 최상의 IT 서비스를 제공하는 Total IT Service 전문기업입니다.
                    </p>
                </div>

                <div className="cont wrap_cont">
                    <div className="cont_p" id="mark1">
                        <h3>개요</h3>
                        <div>
                            <p>
                                와이앤씨스마트앱스는 웹 전반의 컨설팅과 설계, 구축, 운영 업무를 수행하며 서비스, 제조, 통신, 물류, 유통영역에서 <br />
                                빠르게 성장해 나아가고 있습니다. 고객을 위한 최상의 IT 서비스를 제공하는 기업입니다.
                            </p>
                            <table>
                                <colgroup>
                                    <col style={{ width: "130px" }} />
                                    <col />
                                    <col style={{ width: "130px" }} />
                                    <col />
                                </colgroup>
                                <tbody>
                                <tr>
                                    <th>회사명</th><td>(주)와이앤씨스마트앱스</td><th>대표이사</th><td>윤석중</td>
                                </tr>
                                <tr>
                                    <th>설립일</th><td>2012년 8월</td><th>임직원 수</th><td>66명 (2026년 03월 기준)</td>
                                </tr>
                                <tr>
                                    <th>사업분야</th>
                                    <td>
                                        <ul className="list-dash">
                                            <li>IT 부분(스마트팩토리, 비지니스컨설팅, <br />시스템 구축/운영, IT아웃소싱, 인터넷서비스)</li>
                                            <li>영상회의 시스템 솔루션 사업 부문</li>
                                        </ul>
                                    </td>
                                    <th>사업장</th>
                                    <td>본사 (서울 역삼동), 남부사업소(울산)</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* <img src="/resources/img/cont_company_1.gif?v=2" alt="개요" /> */}
                    </div>

                    <div className="cont_p" id="mark2">
                        <h3>비전</h3>
                        <div className="vision">
                            <div className="img_cont">
                                <h4><b>사람과 행복</b></h4>
                                <div className="circle1"></div>
                                <div className="circle2"></div>
                            </div>
                            <div className="cont_txt contxt1">
                                <div className="text_head">
                                    <p><b>세상의 주인, 세상의 중심</b>&nbsp;&nbsp;<strong className="txt_point">사람</strong></p>
                                </div>
                                <p className="text_body">세상의 중심은 사람이며 미래의 다양한 변화에 효과적으로 대응하는 최선의 방법은 사람중심의 경영</p>
                            </div>
                            <div className="cont_txt">
                                <div className="text_head">
                                    <p><b>세상을 돌아가게 하는 힘</b>&nbsp;&nbsp;<strong className="txt_point">행복</strong></p>
                                </div>
                                <p className="text_body">조직공동체내에서 각 구성원의 행복을 극대화하여 세상과 공유할 가치를 창출해 냄</p>
                            </div>
                        </div>
                    </div>

                    <div className="cont_p noLine" id="mark3">
                        <h3>미션</h3>
                        <div className="mission">
                            <div className="cont_fbox">
                                <div className="flexbox fbox1">
                                    <div className="word_img wordimg1"></div>
                                    <div className="headtxt"><b>성실</b><span>Sincerity</span></div>
                                    <div className="bodytxt">
                                        진정성과 집중력으로<br />주어진 역할을 완수하는<br />인재를 육성함
                                    </div>
                                </div>
                                <div className="flexbox">
                                    <div className="word_img wordimg2"></div>
                                    <div className="headtxt"><b>상호존중</b><span>Mutual respect</span></div>
                                    <div className="bodytxt">
                                        권위주의를 지양하고<br />상호 배려와 격려를 통하여<br />성과를 창출할 수 있는<br />환경을 조성함
                                    </div>
                                </div>
                                <div className="flexbox">
                                    <div className="word_img wordimg3"></div>
                                    <div className="headtxt"><b>열망</b><span>Aspiration</span></div>
                                    <div className="bodytxt">
                                        일을 통하여 능동적으로<br />개인의 발전을 추구하며<br />성장해 나아가는 문화를<br />정착시킴
                                    </div>
                                </div>
                                <div className="flexbox">
                                    <div className="word_img wordimg4"></div>
                                    <div className="headtxt"><b>책임감</b><span>Responsibility</span></div>
                                    <div className="bodytxt">
                                        주어진 목표 및 성과에<br />책임을 지도록 사며 성취에<br />대한 합리적이고 공정한<br />보상을 시행함
                                    </div>
                                </div>
                                <div className="flexbox">
                                    <div className="word_img wordimg5"></div>
                                    <div className="headtxt"><b>연대감</b><span>Togetherness</span></div>
                                    <div className="bodytxt">
                                        조직공동체의 전략 및<br />가치를 공유하고 구성원<br />상호간 협력을 기반으로<br />고객, 구성원, 회사의<br />동반성장을 실현함
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>{/* /.cont.wrap_cont */}
            </div>{/* /.container */}
        </>
    );
}
